import React from 'react';
import Image from 'next/image';
import Wine1 from '../../../../../assets/img/track-record/bottleImage_2x-1.png';
import Wine2 from '../../../../../assets/img/track-record/bottleImage_2x-2.png';
import Wine3 from '../../../../../assets/img/track-record/bottleImage_2x-3.png';
import Wine4 from '../../../../../assets/img/track-record/bottleImage_2x-4.png';
import Wine5 from '../../../../../assets/img/track-record/bottleImage_2x-5.png';
import Wine6 from '../../../../../assets/img/track-record/bottleImage_2x-6.png';
import Wine7 from '../../../../../assets/img/track-record/bottleImage_2x-7.png';
import Wine8 from '../../../../../assets/img/track-record/bottleImage_2x-8.png';
import Wine9 from '../../../../../assets/img/track-record/bottleImage_2x-9.png';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import styles from './TrackRecordSection.module.scss';
import Slider from 'react-slick';

export const trackrecordSliderData = [
    {
        id: 0,
        src: Wine8,
        title: 'Dominus, Napa Valley 2011',
        entry: '10 years',
        exit: '12 years',
        returns: '70.55%'
    },
    {
        id: 1,
        src: Wine1,
        title: 'Dom Perignon 2008',
        entry: '13 years',
        exit: '15 years',
        returns: '79.93%'
    },
    {
        id: 2,
        src: Wine2,
        title: 'Gagnard Delagrange, Batard-Montrachet Grand Cru 2018',
        entry: '2 years',
        exit: '5 years',
        returns: '164.79%'
    },
    {
        id: 3,
        src: Wine3,
        title: 'Bruno Colin, Chassagne-Montrachet Premier Cru, Les Chenevottes 2018',
        entry: '2 years',
        exit: '5 years',
        returns: '114.71%'
    },
    {
        id: 4,
        src: Wine4,
        title: 'Domaine Anne-Francoise Gros, Beaune Premier Cru, Les Boucherottes 2017',
        entry: '3 years',
        exit: '6 years',
        returns: '193.04%'
    },
    {
        id: 5,
        src: Wine9,
        title: 'Dom Perignon, Luminous 2010',
        entry: '11 years',
        exit: '13 years',
        returns: '70.71%'
    },
    {
        id: 6,
        src: Wine5,
        title: 'Louis Roederer, Cristal 2008',
        entry: '13 years',
        exit: '15 years',
        returns: '108.38%'
    },
    {
        id: 7,
        src: Wine6,
        title: 'Salon, Le Mesnil-sur-Oger Grand Cru',
        entry: '15 years',
        exit: '19 years',
        returns: '92.99%'
    },
    {
        id: 8,
        src: Wine7,
        title: 'La Spinetta, Barbaresco, Gallina Vursu',
        entry: '5 years',
        exit: '7 years',
        returns: '101.41%'
    }
];

export const TrackRecordSection = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <section className={`${styles.TrackRecordContainer}`} ref={ref}>
            <div className={styles.TrackRecordContent}>
                <div className={`${styles.SlickWrapper} ${runAnimation} ${styles.row3}`}>
                    <div className={`${styles.full}`}>
                        <Slider
                            className={`${styles.TrackrecordSliderContainer}`}
                            accessibility
                            autoplay={false}
                            slidesToShow={2}
                            slidesToScroll={2}
                            arrows
                            dots
                            responsive={[
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        infinite: true,
                                        dots: true
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        infinite: false,
                                        centerMode: false,
                                        arrows: false,
                                        dots: true
                                    }
                                },
                                {
                                    breakpoint: 430,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        infinite: false,
                                        centerMode: false,
                                        arrows: false,
                                        dots: true
                                    }
                                }
                            ]}
                        >
                            {trackrecordSliderData.map(({ id, src, title, returns, entry, exit }) => (
                                <div key={`slider_${id}`} className={`${styles.SlideWrapper}`}>
                                    <div className={`${styles.SlideContainer} ${styles.clean}`}>
                                        <div className={'image'}>
                                            <Image className={'starsRating'} src={src} alt={title} loading={'lazy'} />
                                        </div>
                                        <div className={'text'}>
                                            <h3>{title}</h3>
                                            <div className={'details'}>
                                                <span className={'title'}>Annualized Return</span>
                                                <p className={'value'}>{returns}</p>
                                            </div>
                                            {entry && (
                                                <div className={'details'}>
                                                    <span className={'title'}>Entry Age</span>
                                                    <p className={'value'}>{entry}</p>
                                                </div>
                                            )}
                                            <div className={'details'}>
                                                <span className={'title'}>Exit Age</span>
                                                <p className={'value'}>{exit}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};
